/* eslint-disable global-require */

import angular from 'angular';

import LocationFormController from './location-form.controller';

export default angular.module('autoboard.formLocation', [])
  .directive('formLocation', () => {
    'ngInject';

    return {
      controller: LocationFormController,
      restrict: 'E',
      scope: {
        exit: '&',
        show: '=',
        vehicle: '<',
      },
      templateUrl: require('./location-form.template.html'),
    };
  })
  .name;
